/* Copyright(c) 2019 APSS Media Pvt. Ltd.
 *  All Rights Reserved
 */

/*@author :Sanjana Shende
 *@fileName :addUserAgency.js
 *Desc: Add User
 */

import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { logoutUser } from "../login/authentication";
import { withRouter } from "react-router-dom";
import { FaArrowAltCircleLeft } from "react-icons/fa";
import Footer from "../layouts/footer";
import Navigation from "../layouts/navPage";
import Picky from "react-picky"; //Anshul-5726: added react picky dropdown for agency names
import {
  //Form, // Nilesh-2833-Removing console warnings
  //Input, // Nilesh-2833-Removing console warnings
  Tooltip,
  Icon,
  Table,
  Radio, //Anshul-5726 : added radio button for active and deactivated users
  // Cascader, // Nilesh-2833-Removing console warnings
  // Select, // Nilesh-2833-Removing console warnings
  // Row, // Nilesh-2833-Removing console warnings
  // Col, // Nilesh-2833-Removing console warnings
  // Checkbox, // Nilesh-2833-Removing console warnings
  // Button, // Nilesh-2833-Removing console warnings
  // AutoComplete, // Nilesh-2833-Removing console warnings
  // Card, // Nilesh-2833-Removing console warnings
} from "antd";
// import { ThemeConsumer } from "styled-components"; // Nilesh-2833-Removing console warnings
import { css } from "emotion"; //Sandeep-task-3447-added css file
import "./addUserAgency.css"; //Sandeep-task-3447-added css file
import { fetch_custom as fetch } from "../../configration/fetch_default_headers"; // karan-task-3723-vapt header and query params
const Swal = require("sweetalert2");
const tableCSS = css({
  backgroundColor: "white",
  fontFamily: "sans-serif",
  fontSize: "20px",
  borderStyle: "bold",
  margin: "10px", //Anshul-5726: added margin for table
  boxShadow: "rgba(71, 71, 71, 0.3) 0px 4px 6px 0px", //Anshul-5780
  "& thead > tr > th": {
    backgroundColor: "#144999", //rutuja task -4524 changed background color
    color: "white",
    fontWeight: "500",
    // wordWrap:"break-word",
    // width:'10%'
  },
  "& thead > tr": {
    borderWidth: "2px",
    borderStyle: "solid",
  },
}); //Sandeep-task-3447-added Tablecss file

class AddUserAgency extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      inputClass11: "btn add-button",
      fields: {},
      errors: "",
      loader2: "",
      userDomain: "",
      selectedUserDomain: "@machbizz.com", //Sanjana-3192-For default domain in select dropdown in case user login with "machbizz.com"
      tableSearchText: "",//Rutuja-5461-added to store value for search
      userDetailsSearch: [],//Rutuja-5461-added search data array
      filterStatus: "activeUsers", //Anshul-5726: for storing active or deactivated radio button value
      activatedUsersCheckboxArray: [], //Anshul-5726: added to store the active users
      deactivatedUsersCheckboxArray: [], //Anshul-5726: added to store the deactivated users
      showAgencyMovePopup: false, //Anshul-5726: added move popup and initially set as false
      moveAgencyArray: [], //Anshul-5726: Array to store the users whose orgID to be updated
      disableSaveButton: true, //Anshul-5726: disabled Save button until all input values are not filled
      selectedAgency: [], // Anshul-5726: Added to store the selected agencies agencyID
     

    };
    this.handleChange = this.handleChange.bind(this);
    this.submitUser = this.submitUser.bind(this);
    this.dropDownChange = this.dropDownChange.bind(this); //Sanjana-3192-handleChange function for dropdown in case user login with "machbizz.com"
    this.handleChangeSearch = this.handleChangeSearch.bind(this);//Rutuja-5461-added search function binding 
    this.handleMoveButtonClick = this.handleMoveButtonClick.bind(this); //Anshul-5726: added for fetching the agency names on 'Switch Team' button click
    this.handleClosePopup = this.handleClosePopup.bind(this); //Anshul-5726: added to close the switch team popup
  } // end of constructor
  componentDidMount() {
    // alert("inside didmount");
    // const { isAuthenticated, user } = this.props.auth; // Nilesh-2833-Removing console warnings
    const { user } = this.props.auth;
    // let orgID = user.id; // Nilesh-2833-Removing console warnings
    var userName = user.name;
    userName = userName.split("@");
    var userName1 = "@" + userName[1];
    /* @author Sandeep Dhawale
     * @param  Description get user details
     * @return Description get user details
     */

    this.setState({ loader2: "loader_report1" });

    //Priyanka-5469-Added role condition to call route
    let route = "";
    if(this.props.auth.user.role === "AQA"){
      route = "/users/getAQAUserList"
    } else{
      route = "/users/getUserList"
    }

    fetch(route, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
    }) // karan-task-3723-vapt header and query params
      .then((res) => res.json())
      .then((getUserList) => {
        this.setState({ getUserList: getUserList, loader2: "" });
      })
      .catch(function (err) {
        console.log(err);
      });
    // alert("userName1"+userName1)
    //Sanjana-3192-condition to display single/multiple domain suggestion in case user login with "machbizz.com"
    if (userName[1] === "machbizz.com" || userName[1] === "machbizz.co.in") {
      const selectAfter = (
        <select
          onChange={this.dropDownChange}
          style={{ backgroundColor: "#fafafa", border: "0px solid #d9d9d9" }}
        >
          <option selected name=".machbizz.com" value="@machbizz.com">
            @machbizz.com
          </option>
          <option name=".machbizz.co.in" value="@machbizz.co.in">
            @machbizz.co.in
          </option>
        </select>
      );
      this.setState({ userDomain: selectAfter });
    } else {
      this.setState({ userDomain: userName1 });
    }
  } //end of componentDidMount

  //Sanjana-3192-handleChange function for dropdown in case user login with "machbizz.com"
  dropDownChange(e) {
    // const { name, value } = e.target; // Nilesh-2833-Removing console warnings
    const { value } = e.target;

    this.setState({ selectedUserDomain: value });
  }

  validateForm() {
    // alert("inside validate form");
    let fields = this.state.fields;
    let errors = {};
    let formIsValid = true;
    let spanDisplay = "none";
    // let requiredFeildValidate = "true";
    let requiredFeildValidate = true; //Nilesh-2833-Removing console warnings
    // let userNameValidate = "true";
    let userNameValidate = true; //Nilesh-2833-Removing console warnings
    // let firstNameValidate = "true";
    let firstNameValidate = true; //Nilesh-2833-Removing console warnings
    // let lastNameValidate = "true";
    let lastNameValidate = true; //Nilesh-2833-Removing console warnings
    // let roleValidate = "true";
    let roleValidate = true; //Nilesh-2833-Removing console warnings
    //Sanjana-3192-condition added in validation when user in case user login with "machbizz.com"
    if (
      this.state.selectedUserDomain === "" ||
      this.state.selectedUserDomain === "null" ||
      this.state.selectedUserDomain == null
    ) {
      fields["userName"] = fields["userName"] + this.state.userDomain;
    } else {
      fields["userName"] = fields["userName"] + this.state.selectedUserDomain;
    }
    this.setState({ fields });

    if (
      !fields["userName"] &&
      // !userDomain["userDomain"]&&
      !fields["role"] &&
      !fields["firstName"] &&
      !fields["lastName"]
    ) {
      requiredFeildValidate = false;
      errors["commonError"] = <li>Please fill below required fields</li>;
      this.setState({ errors: errors });
    } else {
      if (
        //Nilesh-2833-Removing console warnings
        this.state.userName === "" ||
        this.state.userName == null ||
        this.state.userName === undefined
      ) {
        userNameValidate = false;
        //errors["userName"] = <li>Please enter user name</li>;
        errors["userName"] = <li>Please enter user name</li>;
        this.setState({ errors: errors });
      } else {
        //shivani - 3599 - changed RegEx as per validation requirement for hyphen .
        // var pattern = new RegExp(/^([a-zA-Z]+[\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,3}(?:\.[a-z]{2})?)$/)
        //sunita-task-3782-below regex accept only business domains.
        //Sandeep-task-3893-Production issue-Email format issue--All roles
        var pattern = new RegExp(
          // eslint-disable-next-line no-useless-escape
          /^\s*$|^[\.a-zA-Z0-9_%+]+[\w-]+[a-zA-Z0-9_%+]+(\.[a-zA-Z0-9]+)*@(?!gmail.com)(?!gmail.co.in)(?!yahoo.com)(?!yahoo.co.in)(?!facebook.com)(?!facebook.co.in)[a-zA-Z0-9]+[\w-]+[a-zA-Z0-9]+\.([a-zA-Z]{3,5}|[a-zA-z]{2,5}\.[a-zA-Z]{2,5})/
        ); //mufiz 4091
          // 5778-Kiran Dhainje -commented This Prod Issue-AC/PC/DC/ADV/AQA-Add User-Blank User Name accepting

      //   if (this.state.userName.match(pattern)) {
      //     // mufiz Task-3984 Settings - Add User - Username should accept EmailID as per tooltip
      //     userNameValidate = true;
      //   } else {
      //     userNameValidate = false;
      //     errors["userName"] = <li>Please enter valid user name</li>;
      //     this.setState({ errors: errors });
      //   } // mufiz Task-3984 Settings - Add User - Username should accept EmailID as per tooltip
      // }

       // Added the confition for this 5778-Kiran Dhainje - This Prod Issue-AC/PC/DC/ADV/AQA-Add User-Blank User Name accepting

          if (!this.state.userName || /^\s*$/.test(this.state.userName)) {
            userNameValidate = false;
            errors["userName"] = <li>User name cannot be blank or spaces</li>;
          this.setState({ errors: errors });
        } else if (this.state.userName.match(pattern)) {
               // existing email regex check
                userNameValidate = true;
               } else {
               userNameValidate = false;
               errors["userName"] = <li>Please enter valid user name</li>;
                      this.setState({ errors: errors });
                   }
      }

      if (
        //Nilesh-2833-Removing console warnings
        this.state.firstName === "" ||
        this.state.firstName == null ||
        this.state.firstName === undefined
      ) {
        firstNameValidate = false;
        errors["firstName"] = <li>Please enter first name</li>;
        this.setState({ errors: errors });
      } else {
        let pattern = new RegExp(/^[a-zA-Z]+$/); // Nilesh-2833-Removing console warnings
        if (!pattern.test(fields["firstName"])) {
          userNameValidate = false;
          errors["firstName"] = <li>please enter valid first name</li>;
          this.setState({ errors: errors });
        } else {
          errors["firstName"] = "";
          this.setState({ errors: errors });
        }
      }
      if (
        //Nilesh-2833-Removing console warnings
        this.state.lastName === "" ||
        this.state.lastName == null ||
        this.state.lastName === undefined
      ) {
        lastNameValidate = false;
        errors["lastName"] = <li>Please enter last name</li>;
        this.setState({ errors: errors });
      } else {
        let pattern = new RegExp(/^[a-zA-Z]+$/); // Nilesh-2833-Removing console warnings
        if (!pattern.test(fields["lastName"])) {
          userNameValidate = false;
          errors["lastName"] = <li>please enter valid last name</li>;
          this.setState({ errors: errors });
        } else {
          errors["lastName"] = "";
          this.setState({ errors: errors });
        }
      }
      if (
        //Nilesh-2833-Removing console warnings
        this.state.role === "" ||
        this.state.role == null ||
        this.state.role === undefined
      ) {
        roleValidate = false;
        errors["role"] = <li>Please enter role</li>;
        this.setState({ errors: errors });
      } else {
        errors["role"] = "";
        this.setState({ errors: errors });
      }
    }

    if (
      requiredFeildValidate === false ||
      userNameValidate === false ||
      firstNameValidate === false ||
      lastNameValidate === false ||
      roleValidate === false
    ) {
      formIsValid = false;
      this.setState({
        errors: errors,
        alertBorder: "1px solid red",
        alertWidth: "1000px",
        alertAlign: "center",
        alertDisplay: "block",
        spanSpaceDisplay: spanDisplay,
      });
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    } else if (
      requiredFeildValidate === true || //// mufiz Task-3984 Settings - Add User - Username should accept EmailID as per tooltip
      userNameValidate === true ||
      firstNameValidate === true ||
      lastNameValidate === true ||
      roleValidate === true
    ) {
      formIsValid = true;
      // alert("success");
    }
    return formIsValid;
  }

  handleChange(e) {
    // alert("inside handle change");
    let fields = this.state;
    // alert("fields=>"+this.state);

    fields[e.target.name] = e.target.value;
    // alert("fields=>"+e.target.name);
    // Anshul-5726: added to search the data in table
    const { name, value } = e.target;
    fields[name] = value;

    const { userName, firstName, lastName, role } = fields;
    const isComplete =
      userName && firstName && lastName && role && role !== "None Selected";
    
    this.setState({ fields,
       [name]: value,
      disableSaveButton: !isComplete,
     });
  }
  //Rutuja-5065-function for Active status route call
  // changeUserStatusActive(e, record) {
  //   var orgID = record.userID;
  //   //Priyanka-5438-Passing role
  //   var role = record.role;
	// 	let data = {
	// 	  orgID: orgID,
  //     role:role,
  //     userName : record.userName  //Priyanka-5468-Passing selected username to BE
  //   };
  //   console.log('active data -- >',data)
  //   fetch("/users/setUserStatusActiveDIQA", {
  //     method: "POST",
  //     headers: { "Content-Type": "application/json" },
  //     body: JSON.stringify(data),
  //   })
  //     .then((res) => res.json())
  //     .then((response) => {
  //       if (response.success === true) {
  //         Swal.fire({
  //           text: "User Activated",
  //           type: "success",
  //           confirmButtonText: "Ok",
  //           allowOutsideClick: false,
  //           preConfirm: () => {
  //             window.location.reload();
  //           },
  //         });
  //       }
  //       else{
  //         //Priyanka-5468-Showing error message
  //         Swal.fire({
  //           text: "User Already exists",
  //           type: "error",
  //           confirmButtonText: "Ok",
  //           allowOutsideClick: false,
  //           preConfirm: () => {
  //             window.location.reload();
  //           },
  //         });
  //       }
  //       this.setState({ isDisabled: true });
  //     });
  // }

  // Anshul-5726: updated above code for sending array of users at BE instead of single user

   changeUserStatusActive() {
      const { deactivatedUsersCheckboxArray } = this.state;
  
      if (
        !Array.isArray(deactivatedUsersCheckboxArray) ||
        deactivatedUsersCheckboxArray.length === 0
      ) {
        console.error("No active users selected for deactivation.");
        return;
      }
  
const data = deactivatedUsersCheckboxArray.map((u) => ({ userID: u.userID }));
    
      fetch("/users/setUserStatusActiveDIQA", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      })
        .then((res) => res.json())
        .then((response) => {
          if (response.success === true) {
            Swal.fire({
              text: "User Activated",
              type: "success",
              confirmButtonText: "Ok",
              allowOutsideClick: false,
              preConfirm: () => {
                window.location.reload();
              },
            });
          } else {
            Swal.fire({
              text: "Some users could not be Activated.",
              type: "error",
              confirmButtonText: "Ok",
              allowOutsideClick: false,
              preConfirm: () => {
                window.location.reload();
              },
            });
          }
          this.setState({ isDisabled: true });
        })
        .catch((error) => {
          console.error("Error in deactivation request:", error);
        });
    }

  //Supriya: Submit User
  submitUser(e) {
    // alert("inside submituser");
    // const { isAuthenticated, user } = this.props.auth; // Nilesh-2833-Removing console warnings
    //Sanjana-3192-condition added to generate final data  when user in case user login with "machbizz.com"/ with "apssmedia.com"
    let data;

    //sunita-task-3782-changed below condition as per requirement
    if (this.state.userDomain) {
      data = {
        // userName: this.state.userName + this.state.userDomain,
        userName: this.state.userName,
        firstName: this.state.firstName,
        lastName: this.state.lastName,
        role: this.state.role,
      }; // karan-task-3723-vapt header and query params
    } else {
      data = {
        userName: this.state.userName + this.state.selectedUserDomain,
        firstName: this.state.firstName,
        lastName: this.state.lastName,
        role: this.state.role,
      }; // karan-task-3723-vapt header and query params
    }

    if (this.validateForm() === false) {
      return;
    } else {
      let errors = {};
      fetch("/users/addUserDetails", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      })
        .then((res) => res.json())
        .then((userDetails) => {
          if (userDetails.length > 0) {
            errors["sameUser"] = <li>User Already Exists</li>;
            this.setState({ errors: errors });
          } else {
            fetch("/users/addUser", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify(data),
            })
              .then(function (response) {
                if (response.status >= 400) {
                  throw new Error("Bad response from server");
                }
                return response.json();
              })
              .then(function (response) {
                // success message with response
                if (response.success === true) {
                  //Nilesh-2833-Removing console warnings
                  Swal.fire({
                    text: "User Added Successfully",
                    type: "success",
                    confirmButtonText: "Ok",
                    allowOutsideClick: false,
                    preConfirm: () => {
                      //sunita-task-3764-commented below code as per naren sir suggestion.
                      // this.props.history.push("/newdashboard", {
                      // 	agencyID: user.id
                      // }
                      // ); //karan-task-3684-replace query params
                      window.location.reload(); //sunita-task-3764-added code for refreshing the page.
                    },
                  });
                } else {
                }
              });
          }
        })
        .catch(function (err) {
          console.log(err);
        });
    }
  }

  //kiran-4596-function for route call
  changeUserStatusInactive(e, record) {
    // const {name, value } = e.target; // Nilesh-2833-Removing console warnings
    // var orgID = record.userID;
    // let data = {
    //   orgID: orgID,
    // };

    // Anshul-5726: updated above code for sending array of users at BE instead of single user
      const { activatedUsersCheckboxArray } = this.state;

    if (
      !Array.isArray(activatedUsersCheckboxArray) ||
      activatedUsersCheckboxArray.length === 0
    ) {
      console.error("No active users selected for deactivation.");
      return;
    }

    const data = activatedUsersCheckboxArray.map((userID) => ({ userID }));
   
    fetch("/users/setUserStatusInactive", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((response) => {
        if (response.success === true) {
          Swal.fire({
            text: "User Deactivated",
            type: "success",
            confirmButtonText: "Ok",
            allowOutsideClick: false,
            preConfirm: () => {
              window.location.reload();
            },
          });
        }
        this.setState({ isDisabled: true });
      });
  }

    //Rutuja-5461-added handleChangeSearch to Search user by firstName,lastName email & role
    handleChangeSearch(e) {
      e.preventDefault();
      let currentList = [];
      // Variable to hold the filtered list before putting into state
      let newList = [];
      let filterData = e.target.value;
      this.setState({filterData})//snehal-task-3574-Publisher side--my report-- filter issue
      // If the search bar isn't empty
      if (e.target.value.toString() === "") { //kiran-2836-Removing console warnings
        newList = this.state.getUserList;
      } else {
        // Assign the original list to currentList
        currentList = this.state.getUserList
        newList = currentList.filter((item) => {
          let obj={};//Somnath Task-3972, Add required comumn in search fields
          obj[`firstName`]=item.firstName;
          obj[`lastName`]=item.lastName;
          obj[`email`]=item.userName;
          obj[`role`]=item.role;
          // change current item to lowercase
          const lc = obj;
          //const lc = item.toLowerCase();
          // change search term to lowercase
          const filter = e.target.value.toLowerCase();
          var data = Object.values(lc);
          var dataFinal = data.toString();
          dataFinal = dataFinal.replace(",", " ");
          var dataToLower = dataFinal.toLowerCase();
          return dataToLower.includes(filter);
        });
      }
      // Anshul-5726: filter search data
      newList = newList.filter((user) => {
    const isActive = user.status === "Y" || user.status === null || user.status === "";
    return this.state.filterStatus === "activeUsers" ? isActive : !isActive;
  });

  this.setState({
    userDetailsSearch: newList,
    tableSearchText: e.target.value,
  });
}
// Anshul-5726 : added to handle checkbox change
handleCheckboxChange = (e, record) => {
  const {
    filterStatus,
    activatedUsersCheckboxArray,
    deactivatedUsersCheckboxArray,
  } = this.state;

  const isChecked = e.target.checked;
  const userData = {
    userID: record.userID,
    role: record.role,
    userName: record.userName 
  };

  let arrayToUpdate =
    filterStatus === "activeUsers"
      ? activatedUsersCheckboxArray
      : deactivatedUsersCheckboxArray;

  const updatedArray = isChecked
    ? [...arrayToUpdate, userData] 
    : arrayToUpdate.filter((u) => u.userID !== record.userID); 

  const newState =
    filterStatus === "activeUsers"
      ? { activatedUsersCheckboxArray: updatedArray }
      : { deactivatedUsersCheckboxArray: updatedArray };

  this.setState(newState);
};//end of checkbox change

// Anshul-5726 : added to fetch the all agencies list
  handleMoveButtonClick() {
 document.body.style.overflow = 'hidden';
    fetch("/users/getUsersToSwitchTeam", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
    })
      .then((res) => res.json())
      .then((agencyList) => {
        this.setState({ agencyList });
      })
      .catch(function (err) {
        console.log("Error fetching agency list:", err);
      });

    this.setState({
      showAgencyMovePopup: true,
    });
  } // end fetch all agency list

// Anshul-5726 : added function to close the popup on cancel button
    handleClosePopup() {
 document.body.style.overflow = 'auto';  
   this.setState({
      showAgencyMovePopup: false,
    });
  }

  // Anshul-5726 : below function is used to updating the users orgID with the selected agencies
   handleMoveAgencyButton = () => {
    const {
      selectedAgency,
      activatedUsersCheckboxArray,
      deactivatedUsersCheckboxArray,
    } = this.state;
  
    if (!selectedAgency || selectedAgency.length === 0) {
      Swal.fire({
        text: "Please select a agecny to move",
        type: "warning",
        confirmButtonText: "Ok",
      });
      return;
    }
  
  const { getUserList } = this.state;
  
  let selectedUserIDs = [];
if (activatedUsersCheckboxArray.length > 0) {
  selectedUserIDs = activatedUsersCheckboxArray.map(u => u.userID);
} else if (deactivatedUsersCheckboxArray.length > 0) {
  selectedUserIDs = deactivatedUsersCheckboxArray.map(u => u.userID);
}
 else {
    Swal.fire({
      text: "No users selected to move",
      type: "warning",
      confirmButtonText: "Ok",
    });
    return;
  }
  
  const selectedUsers = getUserList.filter(user =>
    selectedUserIDs.includes(user.userID)
  );
  
  const moveToUsers = selectedAgency.map((ac) => ({
    moveToUserID: ac.agencyID,
    moveToUserName: ac.agencyName,
    moveToEmail:ac.email,
  }));
 
  
    fetch("/users/updateUserOrgID", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      users: selectedUsers,
      moveToUsers,
    }),
  })
      .then((res) => res.json())
      .then((response) => {
        if (response.success === true) {
          Swal.fire({
            text: "Users Updated Successfully",
            type: "success",
            confirmButtonText: "Ok",
            allowOutsideClick: false,
            preConfirm: () => {
              window.location.reload();
            },
          });
        } else {
          Swal.fire({
            text: "Users Not Updated",
            type: "error",
            confirmButtonText: "Ok",
            allowOutsideClick: false,
          });
        }
  
        this.setState({ showAgencyMovePopup: false });
      })
      .catch((error) => {
        console.error("Error in Update request:", error);
      });
  };//end of handleMoveAgencyButton

  render() {
    const asterisk = {
      color: "red",
    };

// Anshul-5726 : Added to show users in the table according to filter (Active/Deactivated)
       const { getUserList, userDetailsSearch, tableSearchText, filterStatus } =
      this.state;

    let filteredData = tableSearchText === "" ? getUserList : userDetailsSearch;

    filteredData = filteredData?.filter((user) => {
      const isActive =
        user.status === "Y" || user.status === null || user.status === "";
      return filterStatus === "activeUsers" ? isActive : !isActive;
    });

    
    //Sandeep-task-3447-added table to get user details
    const addUserAgency = [
      // Anshul-5726 : added new column for checkboxes
      { 
          title: "",
          dataIndex: "",
          key: "checkbox",
          width: 30,
          align: "center",
          render: (text, record) => {
            const isUserAlreadyActive = this.state.getUserList.some(
              (u) =>
                u.userName === record.userName &&
                u.role === record.role &&
                (u.status === "Y" || u.status === null || u.status === "")
            );
  
            const isDeactivatedView =
              this.state.filterStatus === "deactivatedUsers";
            const shouldDisableCheckbox =
              isUserAlreadyActive && isDeactivatedView;
  
             const isChecked =
      this.state.filterStatus === "activeUsers"
        ? this.state.activatedUsersCheckboxArray.some(
            (u) => u.userID === record.userID
          )
        : this.state.deactivatedUsersCheckboxArray.some(
            (u) => u.userID === record.userID
          );
  
            const checkbox = (
              <input
                type="checkbox"
                checked={isChecked}
                disabled={shouldDisableCheckbox}
                onChange={(e) =>
                  !shouldDisableCheckbox && this.handleCheckboxChange(e, record)
                }
                style={{
                  width: "20px",
                  height: "20px",
                  cursor: shouldDisableCheckbox ? "not-allowed" : "pointer",
                  accentColor: "#0A61AD",
                }}
              />
            );
  
            return (
              <div>
                {shouldDisableCheckbox ? (
                  <Tooltip title="User is already active with this role">
                    <span>{checkbox}</span>
                  </Tooltip>
                ) : (
                  checkbox
                )}
              </div>
            );
          },
        }, //Anshul-5726: end checkboxes
      {
        title: "ID",
        dataIndex: "ID",
        key: "ID",
        width: 40,
        // align: "left",
       align: "Center", //Anshul-5726
        render: (text, record) => (
          <div>
            <span style={{ fontSize: "14px" }}>{record.userID}</span>
          </div>
        ),
      },
      {
        title: "First Name",
        dataIndex: "firstName",
        key: "firstName",
        width: 90,
        // align: "left",
        align: "Center", //Anshul-5726
        render: (text, record) => (
          <div>
            {/* Anshul-5726: removed width to show first name properly in the table */}
            <div style={{ fontSize: "14px"}}> 
              {record.firstName}
            </div>
          </div>
        ),
      },
      {
        title: "Last Name",
        dataIndex: "lastName",
        key: "lastName",
        width: 90,
        // align: "left",
         align: "Center", //Anshul-5726
        render: (text, record) => (
          <div>
            <div class="word-wrap" style={{ fontSize: "14px" }}>
              {record.lastName}
            </div>
          </div>
        ),
      },
      {
        title: "Email",
        dataIndex: "email",
        key: "email",
        width: 150,
        // align: "left",
         align: "Center", //Anshul-5726
        render: (text, record) => (
          <div>
            <span style={{ fontSize: "14px" }}>{record.userName}</span>
          </div>
        ),
      },
      {
        title: "Role",
        dataIndex: "role",
        key: "role",
        width: 60,
        align: "Center",
        render: (text, record) => (
          <div>
            <span style={{ fontSize: "14px" }}>{record.role}</span>
          </div>
        ),
      },
      //kiran-4596-added status and action column
      {
        title: "Status",
        dataIndex: "status",
        key: "status",
        width: 40,
        align: "center",
        render: (text, record) => (
          // Anshul-5726: added colors for status column
          <div>
            <span
              style={{
                fontSize: "14px",
                fontWeight: "bold",
                color: record.status === "N" ? "red" : "green",
              }}
            >
              {record.status === "N" ? "Deactivated" : "Active"}
            </span>
          </div>
        ),
      },
// Anshul-5726: comment below code due to action colomn needed in new requirements

      // {
      //   title: "Action",
      //   dataIndex: "Action",
      //   key: "Action",
      //   width: 40,
      //   align: "Center",
      //   render: (text, record) => (
      //     <div>
      //       {/* Aman-4961-added record.status === "" to AC user with empty user status can Deactive user */}
      //       {record.status === "Y" ||
      //       record.status === null ||
      //       record.status === "" ? (
      //         // Chaitanya-5088-change deactivate button alignment
      //         <button
      //           style={{ padding: "7px 7px", margin: "auto" }}
      //           className={this.state.inputClass11}
      //           onClick={(e) => this.changeUserStatusInactive(e, record)}
      //           // disabled={this.state.isDisabled}
      //           type="submit"
      //         >
      //           Deactive{" "}
      //         </button>
      //       ) : (
      //         //Rutuja-5065-change button to activate login
      //         <button
      //           style={{ padding: "7px 7px", margin: "auto" }}
      //           className={this.state.inputClass11}
      //           onClick={(e) => this.changeUserStatusActive(e, record)}
      //           //disabled='disabled'
      //           type="submit"
      //         >
      //           Activate{" "}
      //         </button>
      //       )}
      //     </div>
      //   ),
      // },
    ];
    return (
      <div>
        <Navigation />
        <div class="container-fluid" style={{ paddingTop: "108px" }}>
          <div class="row">
            {/*mufiz-task-397 add new back button
             */}
            <div class="col-lg-4" id="AddUser" style={{ paddingLeft: "20px" }}>
              <a href="./newdashboard" style={{ color: "#056eb8" }}>
                <FaArrowAltCircleLeft size={32} style={{ float: "left" }} title="Back to Dashboard" />
              </a>
            </div>
          </div>
          <h2
            align="center"
            id="labelDI"
            class="addUsr"
            style={{ marginTop: "-31px" }}
          >
            {/* Anshul-5726: Changed title of page */}
            {/* Anshul-5780: changed title of page */}
            Add/Manage Users
          </h2>

          {/* Anshul-5726: updated below code to show fields in a one row */}

     <div
                 class="card-body"
                 className="cardBodyClass agencyBodyClass"
                 style={{
                   margin: "10px",
                   backgroundColor: "#fff",
                   borderRadius: "4px",
                   boxShadow: "grey 1px 1px 6px 0px", //mufiz-task-3975 styling a box
                 }}
               >
                 {/* <legend className="legend labelsubheading">User Details</legend> */}
                 {/* //shivani-3284-passed ID for DI label consistency */}
                 {/*Anshul-5726: commented below div */}
                 {/* <div class="col-12" style={{ textAlign: "center" }}></div> 
     
                 <div style={{ fontSize: "14px", color: "red" }}>
                   {this.state.errors.commonError}
                 </div>
                 <div
                   className="errorMsg"
                   style={{ fontSize: "14px", color: "red" }}
                 >
                   {this.state.errors.userName}
                   {this.state.errors.role}
                   {this.state.errors.firstName}
                   {this.state.errors.lastName}
                   {this.state.errors.sameUser}
                 </div> */}
                 {/* <div class="row">  */}{" "}
                 {/* anshul-5726: added new div to show fields in one row */}
                 <div
                   className="user-input-container"
                   style={{
                     display: "flex",
                     gap: "75px",
                     alignItems: "flex-end",
                     flexWrap: "wrap",
                   }}
                 >
                   {" "}
                   {/* anshul-5726: added new div to combine all fields in one row */}
                   {/* <div class="col-xs-12 col-sm-12 col-md-2 col-lg-4" >
              <label id="label">User Name <span style={asterisk}>*&nbsp; 
              <Tooltip title=" User name should be Valid Email Id.">
              <Icon type="question-circle-o" />
            </Tooltip></span></label>
              <input
              value={this.state.userName}
              onChange={this.handleChange}
              type="text"
              id="userName"
              className="form-control"
              name="userName"
              style={{ width: "60%", height: "60%" }}
              required />
            </div> */}
                   {/* <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4"> */}{" "}
                   {/* anshul-5726 : commented above div and added new div */}
                   <div style={{ flex: 1 }}>
                     {" "}
                     {/*Anshul-5726:  Updated to col-md-2 for 5 equal columns */}
                     <label id="label">
                       User Name{" "}
                       <span style={asterisk}>
                         *&nbsp;
                         <Tooltip title=" User name should be Valid Email Id.">
                           <Icon
                             type="question-circle-o"
                             className="iconbackground"
                           />
                           {/*sunita-task-3818-added classname as per requirement for removing white patches */}
                         </Tooltip>
                       </span>
                     </label>
                     {/* <br /> */}
                     {/* Anshul-5726: removed react Input and added HTML input */}
                     <input
                       // addonAfter={this.state.userDomain} //sunita-task-3782-commented this attribute as want to enable the domain field.
                       value={this.state.userName}
                  onChange={this.handleChange}
                  onKeyDown={(e)=>{
                    if(e.key===" ")e.preventDefault();
                  }} // 5778- Kiran Dhainje -This Prod Issue-AC/PC/DC/ADV/AQA-Add User-Blank User Name accepting
                       type="text"
                       id="userNameNew" 
                       className="form-control"
                       name="userName"
                       style={{
                         width: "100%",
                         height: "60%",
                         borderRadius: "10px",
                         boxShadow: "rgba(71, 71, 71, 0.3) 0px 4px 6px 0px",
                       }} // Anshul-5726: changed width from 60% to 100%, removed padding
                       required
                     ></input>
                   </div>
                   {/* <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 Proleinputbox"> */}
                   {/* Anshul-5726: comment above div and added new with flex 1 */}
                   {/* </div> */}{" "}
                   {/* anshul-5726: commented div to show fields in one row */}
                   {/* <br /> */}
                   {/* end of 1st row */}
                   {/* <div class="row"> */}{" "}
                   {/* anshul-5726: commented div to show fields in one row */}
                   {/* <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4"> */}
                   <div style={{ flex: 1 }}>
                     {" "}
                     {/*Anshul-5726:  Updated to col-md-2 for 5 equal columns */}
                     <label id="label">
                       First Name <span style={asterisk}>*</span>
                     </label>
                     <input
                       value={this.state.firstName}
                       onChange={this.handleChange}
                       type="text"
                       id="firstName"
                       className="form-control"
                       name="firstName"
                       style={{
                         width: "100%",
                         height: "60%",
                         borderRadius: "10px",
                         boxShadow: "rgba(71, 71, 71, 0.3) 0px 4px 6px 0px",
                       }} // Anshul-5726: Set width to 100%, removed padding
                       required
                     />
                   </div>
                   {/* <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 Proleinputbox"> */}
                   <div style={{ flex: 1 }}>
                     {" "}
                     {/*Anshul-5726:  Updated to col-md-2 for 5 equal columns */}
                     <label id="label">
                       Last Name <span style={asterisk}>*</span>
                     </label>
                     <input
                       value={this.state.lastName}
                       onChange={this.handleChange}
                       type="text"
                       id="lastName"
                       className="form-control"
                       name="lastName"
                       style={{
                         width: "100%",
                         height: "60%",
                         borderRadius: "10px",
                         boxShadow: "rgba(71, 71, 71, 0.3) 0px 4px 6px 0px",
                       }} // Anshul-5726: Set width to 100%, removed padding
                       required
                     />
                   </div>
                   <div style={{ flex: 1 }}>
                     {" "}
                     {/*Anshul-5726:  Updated to col-md-2 for 5 equal columns */}
                     {/*sunita-task-3782-added classname as per requirement */}
                      <label id="label">
                  Role <span style={asterisk}>*</span>
                </label>
                {/* Priyanka-5469-Added role condition to display dropdown values*/}
                {this.props.auth.user.role === "AQA" ? 
                  <select
                  value={this.state.role}
                  onChange={this.handleChange}
                  type="text"
                  id="role"
                  className="form-control"
                  name="role"
                style={{
                         width: "100%",
                         height: "60%",
                         borderRadius: "10px",
                         boxShadow: "rgba(71, 71, 71, 0.3) 0px 4px 6px 0px",
                       }}
                  required
                >
                  <option value="None Selected" disabled selected>
                    None Selected
                  </option>
                  <option value="AQA">Quality Assurance</option>
                </select>
                :
                  <select
                    value={this.state.role}
                    onChange={this.handleChange}
                    type="text"
                    id="role"
                    className="form-control"
                    name="role"
                   style={{
                         width: "100%",
                         height: "60%",
                         borderRadius: "10px",
                         boxShadow: "rgba(71, 71, 71, 0.3) 0px 4px 6px 0px",
                       }}
                    required
                  >
                    <option value="None Selected" disabled selected>
                      None Selected
                    </option>
                    <option value="AC">Agency Commercial</option>
                    <option value="ANC">Agency Non-Commercial</option>
                    <option value="AC-ACCOUNT">Accounting</option>
                    <option value="AQA">Quality Assurance</option>
                  </select>
  }
                   </div>
                   <div style={{ flex: 1 }}>
                     {" "}
                     {/*Anshul-5726:  Updated to col-md-2 for 5 equal columns */}
                     <Tooltip
                       title={
                         this.state.disableSaveButton
                           ? "All fields marked with * are mandatory"
                           : ""
                       }
                     >
                       <span>
                         <button
                           style={{
                             width: "40%",
                             margin: "0px",
                             marginLeft: "50px",
                             borderRadius: "10px",
                             boxShadow: "rgba(71, 71, 71, 0.3) 0px 4px 6px 0px",
                           }}
                           className="btn add-button buttonSave"
                           onClick={this.submitUser}
                           type="submit"
                           disabled={this.state.disableSaveButton}
                         >
                          {/* Anshul-5780: changed button label */}
                           Add {/*Mufiz-Bug-3910  */}
                         </button>
                       </span>
                     </Tooltip>
                   </div>
                 </div>
                 {/* </div> */}{" "}
                 {/* anshul-5726: commented div to show fields in one row */}
                 {/* end of 2nd row */}
                 {/* <br /> */} {/* Anshul-5726:*/}
                 {/* locale={this.state.loading1?locale:"No Data"} */}
                 {/* pagination={{ pageSize: this.state.pageSize1 }} */}
                 {/* Anshul-5721: added error message below input fields */}
                 <div class="col-12" style={{ textAlign: "center" }}></div>
                 <div style={{ fontSize: "14px", color: "red" }}>
                   {this.state.errors.commonError}
                 </div>
                 <div
                   className="errorMsg"
                   style={{ fontSize: "14px", color: "red", marginTop: "10px" }}
                 >
                   {this.state.errors.userName}
                   {this.state.errors.role}
                   {this.state.errors.firstName}
                   {this.state.errors.lastName}
                   {this.state.errors.sameUser}
                 </div>
               </div>
               </div>


          {/* end of card body */}
      
        {/* end of container-fluid */}
        {/* //Rutuja-5461-added input for serach*/}
     <div
  className="d-flex justify-content-between align-items-center"
  style={{ width: "100%" }}
>
  {/* Left: Radio buttons */}
  <div style={{ marginLeft: "15px", marginTop: "15px" }}>
       <Radio.Group
                  className="lead-radio"
                  value={this.state.filterStatus}
                  onChange={(e) => {
                    const selectedFilter = e.target.value;
                    this.setState({
                      filterStatus: selectedFilter,
                      activatedUsersCheckboxArray:
                        selectedFilter === "deactivatedUsers"
                          ? []
                          : this.state.activatedUsersCheckboxArray,
                          deactivatedUsersCheckboxArray:
                           selectedFilter === "activeUsers"
                          ? []
                          : this.state.deactivatedUsersCheckboxArray,
                    });
                  }}
                >

              {/* Anshul-5726: start move popup */}
              {this.state.showAgencyMovePopup && (
                <div
                  style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                    zIndex: 9999,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <div
                    onClick={(e) => e.stopPropagation()}
                    style={{
                      backgroundColor: "#fff",
                      padding: "20px",
                      borderRadius: "10px",
                      width: "700px",
                      maxHeight: "70vh",
                      overflowY: "auto",
                      boxShadow: "0 2px 10px rgba(0,0,0,0.3)",
                    }}
                  >
                    <div
                      style={{ display: "flex", gap: "20px", margin: "30px" }}
                    >
                      {/* select agency dropdown */}
                      <div style={{ flex: 1 }}>
                        <label id="label">
                          Select Agency:<span style={asterisk}>*</span>
                        </label>
                        <Picky
                          value={this.state.selectedAgency}
                          options={this.state.agencyList || []}
                          onChange={(selected) =>
                            this.setState({ selectedAgency: selected })
                          }
                          multiple={true}
                          dropdownHeight={250}
                          labelKey="agencyName"
                          valueKey="agencyID"
                        />
                      </div>

                      <div
                        style={{
                          width: "1px",
                          height: "300px",
                          backgroundColor: "#bababa",
                        }}
                      ></div>

                      
                      <div style={{ flex: 1 }}>
                        <label id="label">Selected Agency:</label>

                        {this.state.selectedAgency.length === 0 ? (
                          <div style={{ marginTop: "10px", color: "#888" }}>
                            No Agency selected
                          </div>
                        ) : (
                          <ul style={{ marginTop: "10px" }}>
                            {this.state.selectedAgency.map((ac, index) => (
                              <li key={index}>{ac.agencyName}</li>
                            ))}
                          </ul>
                        )}
                      </div>
                    </div>

                    {/* start move and cancel  button */}
                    <div
                      style={{
                        textAlign: "right",
                        paddingRight: "1%",
                        //   marginBottom: "-3%",
                      }}
                    >
                      <div
                        style={{
                          position: "relative",
                          display: "inline-block",
                        }}
                      >
                        <button
                          type="submit"
                          className="btn"
                          onClick={this.handleMoveAgencyButton}
                          style={{
                            backgroundImage:
                              "linear-gradient(to left, #0777cb, #103784)",
                            color: "white",
                            padding: "0px",
                            width: "100px",
                            height: "30px",
                            marginLeft: "10px",
                            borderRadius: "10px",
                            boxShadow: "rgba(71, 71, 71, 0.3) 0px 4px 6px 0px",
                          }}
                          disabled={this.state.selectedAgency.length === 0}
                        >
                          Switch Team
                        </button>
                      </div>

                      <button
                        className="btn"
                        type="submit"
                        onClick={this.handleClosePopup}
                        style={{
                          marginLeft: "10px",
                          backgroundColor: "red",
                          color: "white",
                          height: "30px",
                          width: "100px",
                          padding: "0px",
                          borderRadius: "10px",
                          boxShadow: "rgba(71, 71, 71, 0.3) 0px 4px 6px 0px",
                        }}
                      >
                        Cancel
                      </button>
                    </div>

                    {/* end move and cancel  button */}
                  </div>
                </div> //main div
              )}

              {/* Anshul-5726 end move popup */}



      <Radio value="activeUsers">Active Users</Radio>
      <Radio value="deactivatedUsers">Deactivated Users</Radio>
    </Radio.Group>
  </div>

  {/* Right: Search */}
  <div
    className="d-flex align-items-center"
    style={{ gap: "8px" }}
  >
    <Tooltip title="Find the user's by Email/First Name/Last Name or role.">
      <Icon type="question-circle-o" className="iconbackground"
       style={{ marginTop: "10px" }} /> 
    </Tooltip>
    <input
      type="text"
      id="search_agency_addUser"
      className="form-control search_agency_addUser"
      value={this.state.filterData}
      onChange={this.handleChangeSearch}
      placeholder="Search..."
      title="Search"
      style={{
        backgroundImage: "url(searchIcon.png)",
        backgroundPosition: "15px 6px",
        backgroundSize: "15px 15px",
        backgroundRepeat: "no-repeat",
        height: "20px",
        fontSize: "12px",
        borderRadius: "25px", //Anshul-5726: Increases the border radius border: "1px solid rgb(221, 221, 221)",
        padding: "16px 20px 16px 34px",
        marginTop: "10px",        // Anshul-5726: added margin for search input
        boxShadow: "rgba(71, 71, 71, 0.3) 0px 4px 6px 0px",
      }}
    />
  </div>
</div>

        <br />
        <div id={this.state.loader2} />
         <p>
  {this.state.tableSearchText === "" ? (
    <Table
      {...this.state.tableState}
      bordered
      dataSource={filteredData} // use filtered data here
      rowKey="campID"
      columns={addUserAgency}
      className={`${tableCSS} "ant-table-thead"`}
      scroll={{y: 250 }}
    />
  ) : (
    <Table
      {...this.state.tableState}
      bordered
      dataSource={this.state.userDetailsSearch}
      rowKey="campID"
      columns={addUserAgency}
      className={`${tableCSS} "ant-table-thead table-responsive"`}
      
    />
  )}
</p>
{/* Anshul-5780: hides the switch team button for the deactivated users and changed the position of the buttons */}
<div
  style={{
    display: "flex",
    justifyContent: "flex-end",
    gap: "20px",
    marginTop: "20px",
    marginRight: "20px",
  }}
>
  {this.state.filterStatus === "activeUsers" && (
    <button
      className="btn add-button buttonSave"
      type="submit"
      disabled={this.state.activatedUsersCheckboxArray.length === 0}
      onClick={this.handleMoveButtonClick}
      style={{
        width: "120px",
        borderRadius: "10px",
        boxShadow: "rgba(71, 71, 71, 0.3) 0px 4px 6px 0px",
      }}
    >
      Switch Team
    </button>
  )}

  {this.state.filterStatus === "deactivatedUsers" ? (
    <button
      className="btn add-button buttonSave"
      type="submit"
      disabled={this.state.deactivatedUsersCheckboxArray.length === 0}
      onClick={() => this.changeUserStatusActive()}
      style={{
        width: "120px",
        borderRadius: "10px",
        boxShadow: "rgba(71, 71, 71, 0.3) 0px 4px 6px 0px",
      }}
    >
      Activate
    </button>
  ) : (
    <button
      className="btn add-button buttonSave"
      type="submit"
      disabled={this.state.activatedUsersCheckboxArray.length === 0}
      onClick={() => this.changeUserStatusInactive()}
      style={{
        width: "120px",
        borderRadius: "10px",
        boxShadow: "rgba(71, 71, 71, 0.3) 0px 4px 6px 0px",
      }}
    >
      Deactivate
    </button>
  )}
</div>


        <br />

        <Footer />
      </div>
    );
  } // end of render
} // end of class

/**
 * @author Narendra Phadke
 * @param  Description handle the login authentication
 * @return Description return All details of authentication
 */
AddUserAgency.propTypes = {
  logoutUser: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, { logoutUser })(
  withRouter(AddUserAgency)
);
